import { ComponentBase } from 'utils/abstract-classes/component-base'
import ModalComponent from '../modal'
import { ATTR_NAME } from 'constants/attr-name'
import { EventType } from 'constants/enums'

export class RecommendationsComponent extends ComponentBase {
    public constructor(protected recommendation: HTMLDivElement) {
        super()
        const modalId = this.recommendation.getAttribute(
            ATTR_NAME.main.recommendations.id
        )
        if (modalId) {
            const modalRecommendation = new ModalComponent(undefined, modalId)
            if (modalRecommendation) {
                document.addEventListener(
                    EventType.OPEN_RECOMMENDATION_MODAL,
                    () => {
                        modalRecommendation.openModal()
                        this.trackModalViewEvent()
                    }
                )
            }
        }
    }

    /**
     * This method is used to track the modal view event
     */
    private trackModalViewEvent() {
        document.dispatchEvent(
            new CustomEvent('custom-event', {
                detail: {
                    control_fields: {
                        mparticle: {
                            keys: {
                                modal_name: 'modal_name'
                            },
                            mp_event_type: 'UserPreference'
                        }
                    },
                    event_name: 'modal_view',
                    modal_name: 'welcome_to_my_topics'
                }
            })
        )
    }
}
